import { ReactNode } from 'react';
import * as React from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { FieldErrorMessage } from '../errors/FieldErrorMessage';

const InputElement = styled.input`
	display: none;
`;

const LabelElement = styled.label`
	color: ${(props) => props.theme.colors.primary};
	opacity: 0.6;
	margin-right: 30px;
	cursor: pointer;

	&:before {
		width: 20px;
		height: 20px;
		border-radius: 10px;
		content: '';
		margin-right: 8px;
		display: inline-block;
		vertical-align: middle;
		box-sizing: border-box;
		border: 1px solid ${(props) => props.theme.colors.primary};
	}

	svg {
		vertical-align: middle;
		margin-right: 4px;
		width: 24px;

		* {
			fill: ${(props) => props.theme.colors.primary};
		}
	}

	input[type='radio']:checked + & {
		opacity: 1;

		svg * {
			fill: ${(props) => props.theme.colors.yellow};
		}

		&:before {
			border-width: 6px;
		}
	}
`;

interface IBaseProps {
	id?: string;
	name?: string;
	label: string;
	value: string;
	icon?: ReactNode;
}

interface IElementProps extends IBaseProps {
	checked?: boolean;
	onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButton = ({
	id,
	name,
	label,
	value,
	icon,
	checked,
	onClick,
	onChange,
}: IElementProps) => (
	<Box>
		<InputElement
			id={id}
			name={name}
			type="radio"
			value={value}
			checked={checked}
			onChange={onChange}
			onClick={onClick}
		/>
		<LabelElement htmlFor={id}>
			{icon}
			{label}
		</LabelElement>
		{name && <FieldErrorMessage name={name} />}
	</Box>
);
